module.exports = __webpack_public_path__ + "01_short_black.6a98cb3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/01_short_black.png
// module id = Nee3
// module chunks = 0